import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class FeatureFlagFormController extends Controller {
  static targets = ['audienceType', 'roleSection', 'audienceSection', 'subscriptionToggle', 'subscriptionSection']

  connect () {
    this.toggleSections()
  }

  toggleSections () {
    const subscriptionChecked = this.hasSubscriptionToggleTarget && this.subscriptionToggleTarget.checked

    if (this.hasSubscriptionToggleTarget && this.hasSubscriptionSectionTarget) {
      this.subscriptionSectionTarget.classList.toggle('hidden', !subscriptionChecked)
    }

    if (this.hasAudienceSectionTarget) {
      this.audienceSectionTarget.classList.toggle('opacity-50', subscriptionChecked)
      this.audienceSectionTarget.classList.toggle('pointer-events-none', subscriptionChecked)

      if (subscriptionChecked) {
        this.audienceTypeTarget.value = 'all_users'
      }
    }

    const audienceValue = this.audienceTypeTarget.value
    this.roleSectionTarget.classList.toggle('hidden', subscriptionChecked || audienceValue !== 'role')
  }
}

stimulus.register('feature-flag-form', FeatureFlagFormController)
